import Component from '../core/Component'
import debounce from 'lodash/debounce'
import { substitute } from '../utils/String'

export const STATES = {
    ACTIVE: 'is-active',
}

export default class StoreSearch extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            input: null,
            list: null,
            template: null,
        }

        if (this.element.dataset.url) {
            this.options.url = this.element.dataset.url
        }

        this.isReady = false
        this.request = null
        this.cache = {}
        this.items = []

        this.handleKeyup = debounce(this.handleKeyup.bind(this), 100)
    }

    prepare() {
        this.template = this.ref.template.textContent.trim()
        this.ref.input.addEventListener('input', this.handleKeyup)
        this.ref.input.addEventListener('focus', this.handleFocus)

        document.addEventListener('click', this.handleOuterClick)
    }

    destroy() {
        document.removeEventListener('click', this.handleOuterClick)
    }

    handleOuterClick = (event) => {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    handleFocus = (event) => {
        if (this.ref.input.value.trim() !== '' && this.items.length) {
            this.open()
        }
    }

    handleKeyup = (event) => {
        if (this.request) {
            this.request.abort()
        }

        const value = this.ref.input.value.trim()

        if (!value) {
            this.handleResults([])
            return
        }

        if (value in this.cache) {
            this.handleResults(this.cache[value])
        }

        this.request = $.ajax({
            url: this.options.url.replace('%QUERY', value),
            method: this.element.method || 'POST',
            success: (response) => {
                const items = response.map((item) => {
                    if (!Array.isArray(item.floors)) {
                        item.floors = [item.floors]
                    }
                    return item
                })

                this.cache[value] = items
                this.handleResults(items)
            },
        })
    }

    handleResults = (items) => {
        this.ref.list.innerHTML = items
            .slice(0, 10)
            .map((item) => substitute(this.template, item))
            .join('')

        this.items = items

        if (this.items.length) {
            this.open()
        } else {
            this.close()
        }
    }

    close() {
        this.element.classList.remove(STATES.ACTIVE)
    }

    open() {
        this.element.classList.add(STATES.ACTIVE)
    }
}
